// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__F2jWW","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__-PUxc"};